var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "quotationDetail",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.quotation.quotationNo || this.$t("Pricing.Quotation"),
            width: _vm.isZh ? "1450px" : "1530px",
            top: "5vh",
            "close-on-click-modal": false
          },
          on: { close: _vm.handleClose }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "column" } },
            [
              _c(
                "el-form",
                { staticClass: "section" },
                [
                  _c(
                    "el-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editing,
                          expression: "editing"
                        }
                      ]
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showDetail && _vm.canUpdate,
                                  expression: "showDetail && canUpdate"
                                }
                              ],
                              attrs: { no: "onSave", type: "success" },
                              on: { click: _vm.onSave }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Save")))]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.canUpdate,
                                  expression: "canUpdate"
                                }
                              ],
                              attrs: { no: "onCancel", type: "success" },
                              on: { click: _vm.onCancel }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Cancel")))]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showDetail,
                                  expression: "showDetail"
                                }
                              ],
                              attrs: { no: "onPrint", type: "primary" },
                              on: { click: _vm.onPrint }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Print")))]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.$checkPermission([
                                      "module_RemoteBooking"
                                    ]) &&
                                    _vm.quotation &&
                                    _vm.quotation.uuid &&
                                    !_vm.associatedInquiry,
                                  expression:
                                    "$checkPermission(['module_RemoteBooking']) && quotation && quotation.uuid && !associatedInquiry"
                                }
                              ],
                              attrs: { no: "onRemoteBooking", type: "primary" },
                              on: { click: _vm.onRemoteBooking }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.RemoteBooking")))]
                          ),
                          _vm.canUpdate && _vm.quotation.status2
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    disabled:
                                      _vm.quotation.status2 ===
                                      _vm.SystemConstants.QUOTE_STATUS_QUOTED
                                        .code,
                                    type: "primary",
                                    no: "submit"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.editStatus(
                                        _vm.SystemConstants.QUOTE_ACTION_SUBMIT
                                          .code
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_SubmitQuotation")
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.canUpdate && _vm.quotation.status2
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    disabled:
                                      _vm.quotation.status2 ===
                                      _vm.SystemConstants.QUOTE_STATUS_PENDING
                                        .code,
                                    type: "primary",
                                    no: "revoke"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.editStatus(
                                        _vm.SystemConstants.QUOTE_ACTION_REVOKE
                                          .code
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_WithdrawQuotation")
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.canUpdate && _vm.quotation.status2
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    disabled:
                                      _vm.quotation.status2 !==
                                      _vm.SystemConstants.QUOTE_STATUS_PENDING
                                        .code,
                                    type: "primary",
                                    no: "refuse"
                                  },
                                  on: {
                                    click: function(p) {
                                      _vm.refuseQuotationDialog.visible = true
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_RejectQuotation")
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "margin-left": "15px",
                                "font-size": "14px",
                                color: "red"
                              },
                              attrs: { no: "status" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.ColumnUtils.showTypeLabelFunc(
                                    _vm.quotation.status2,
                                    _vm.SystemConstants.QUOTE_STATUS
                                  ) +
                                    (_vm.quotation.refuseReason
                                      ? "(" + _vm.quotation.refuseReason + ")"
                                      : "")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  staticClass: "section",
                  attrs: {
                    "label-width": _vm.isZh ? "110px" : "130px",
                    "label-position": "right",
                    disabled: _vm.associatedInquiry
                  }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: true,
                        "label-width": _vm.isZh ? "110px" : "130px",
                        "label-position": "right",
                        disabled: _vm.associatedInquiry
                      }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { "label-width": "0" } },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          style: _vm.isZh
                                            ? "width:85px;"
                                            : "width:105px;",
                                          attrs: {
                                            no: "clientType",
                                            disabled: !_vm.editing
                                          },
                                          on: {
                                            change:
                                              _vm.ddlClientTypeChangeHandler
                                          },
                                          model: {
                                            value: _vm.quotation.clientType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.quotation,
                                                "clientType",
                                                $$v
                                              )
                                            },
                                            expression: "quotation.clientType"
                                          }
                                        },
                                        _vm._l(
                                          _vm.PriceConstant.CLIENT_TYPE_LIST,
                                          function(item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: _vm.isZh
                                                  ? item.chineseName
                                                  : item.englishName,
                                                value: item.code
                                              }
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                      _vm.quotation.clientType === 1
                                        ? _c("cargo-company-select", {
                                            ref: "quotationZsName",
                                            attrs: {
                                              no: "clientId",
                                              disabled: !_vm.editing,
                                              "custom-style":
                                                _vm.formItemWidth +
                                                "padding-left: 5px;",
                                              "method-params": {
                                                customer: true,
                                                active: true
                                              },
                                              "default-value":
                                                _vm.quotation.clientId ||
                                                undefined
                                            },
                                            on: { change: _vm.onClientChange }
                                          })
                                        : _vm._e(),
                                      _vm.quotation.clientType === 0 &&
                                      !_vm.associatedInquiry
                                        ? _c("cargo-advance-select", {
                                            ref: "quotationLsName",
                                            style:
                                              _vm.formItemWidth +
                                              "padding-left: 5px;",
                                            attrs: {
                                              no: "clientId",
                                              disabled: !_vm.editing,
                                              "custom-label": function(item) {
                                                return (
                                                  "[" +
                                                  _vm.branchMap.get(
                                                    item.branchId
                                                  ) +
                                                  "]" +
                                                  item.name
                                                )
                                              },
                                              "show-custom-label-in-option": true,
                                              filterable: "",
                                              "default-value":
                                                _vm.quotation.clientId ||
                                                undefined,
                                              cache: false,
                                              "tag-name": "name",
                                              "tag-value": "clientId",
                                              "filter-tag-names": [
                                                "code",
                                                "name"
                                              ],
                                              "static-options":
                                                _vm.filter.clientList
                                            },
                                            on: {
                                              parentCallBack: _vm.onClientChange
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.quotation.clientType === 0 &&
                                      _vm.associatedInquiry
                                        ? _c("el-input", {
                                            ref: "quotationLsName",
                                            attrs: { no: "clientId" },
                                            model: {
                                              value: _vm.quotation.tempClientId,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.quotation,
                                                  "tempClientId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "quotation.tempClientId"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.quotation.clientType === 0
                                        ? _c("span", [
                                            _c("img", {
                                              staticStyle: {
                                                "vertical-align": "sub",
                                                "margin-left": "3px",
                                                cursor: "pointer"
                                              },
                                              attrs: {
                                                src: require("@/assets/add.png"),
                                                title: _vm.$t(
                                                  "Pricing.AddNewCustomer"
                                                ),
                                                height: "16",
                                                width: "16"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.onAddClient()
                                                }
                                              }
                                            })
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Pricing.QuotationValidFrom")
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          no: "beginDate",
                                          type: "date",
                                          "value-format": "yyyy-MM-dd",
                                          disabled: !_vm.editing,
                                          clearable: false,
                                          editable: false
                                        },
                                        model: {
                                          value: _vm.quotation.beginDate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.quotation,
                                              "beginDate",
                                              $$v
                                            )
                                          },
                                          expression: "quotation.beginDate"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "padding-left": "4px",
                                            "padding-right": "4px"
                                          }
                                        },
                                        [_vm._v(" - ")]
                                      ),
                                      _c("el-date-picker", {
                                        attrs: {
                                          no: "endDate",
                                          type: "date",
                                          "value-format": "yyyy-MM-dd",
                                          disabled: !_vm.editing,
                                          clearable: false,
                                          editable: false
                                        },
                                        model: {
                                          value: _vm.quotation.endDate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.quotation,
                                              "endDate",
                                              $$v
                                            )
                                          },
                                          expression: "quotation.endDate"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Pricing.BusinessType")
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { disabled: !_vm.editing },
                                      model: {
                                        value: _vm.quotation.jobType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.quotation,
                                            "jobType",
                                            $$v
                                          )
                                        },
                                        expression: "quotation.jobType"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { display: "flex" } },
                                        [
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: {
                                                no: "onCancel",
                                                label: 0
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Pricing.jobTypeExport"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: {
                                                no: "onCancel",
                                                label: 1
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Pricing.jobTypeImport"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.Contact") } },
                            [
                              _c("el-input", {
                                ref: "quotationContact",
                                attrs: {
                                  no: "contact",
                                  disabled: !_vm.editing
                                },
                                model: {
                                  value: _vm.quotation.contact,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quotation, "contact", $$v)
                                  },
                                  expression: "quotation.contact"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.Phone") } },
                            [
                              _c("el-input", {
                                ref: "quotationPhone",
                                attrs: { no: "phone", disabled: !_vm.editing },
                                model: {
                                  value: _vm.quotation.phone,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quotation, "phone", $$v)
                                  },
                                  expression: "quotation.phone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.Fax") } },
                            [
                              _c("el-input", {
                                attrs: { no: "fax", disabled: !_vm.editing },
                                model: {
                                  value: _vm.quotation.fax,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quotation, "fax", $$v)
                                  },
                                  expression: "quotation.fax"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.Email") } },
                            [
                              _c("el-input", {
                                attrs: { no: "email", disabled: !_vm.editing },
                                model: {
                                  value: _vm.quotation.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quotation, "email", $$v)
                                  },
                                  expression: "quotation.email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("Pricing.PlaceOfReceipt") }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  no: "receiptPlace",
                                  disabled: !_vm.editing
                                },
                                model: {
                                  value: _vm.quotation.receiptPlace,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quotation, "receiptPlace", $$v)
                                  },
                                  expression: "quotation.receiptPlace"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.POL") } },
                            [
                              _vm.quotation.type !=
                              _vm.PriceConstant.QUOTATION_AIR
                                ? _c("cargo-advance-select", {
                                    ref: "quotationSePol",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "pol",
                                      disabled: !_vm.editing,
                                      filterable: "",
                                      placeholder: _vm.$t("Pricing.POLPrompt"),
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Seaport,
                                      "custom-label": function(item) {
                                        return (
                                          "[" +
                                          item.code +
                                          "]" +
                                          item.englishName
                                        )
                                      },
                                      "filter-tag-names": [
                                        "code",
                                        "englishName"
                                      ],
                                      "show-custom-label-in-option": true,
                                      "default-value": _vm.quotation.pol
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.polChange(p)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm.quotation.type ==
                              _vm.PriceConstant.QUOTATION_AIR
                                ? _c("cargo-advance-select", {
                                    ref: "quotationAirPol",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "pol",
                                      disabled: !_vm.editing,
                                      filterable: "",
                                      placeholder: _vm.$t("Pricing.POLPrompt"),
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Airport,
                                      "custom-label": function(item) {
                                        return (
                                          "[" +
                                          item.code +
                                          "]" +
                                          item.englishName
                                        )
                                      },
                                      "filter-tag-names": [
                                        "code",
                                        "englishName"
                                      ],
                                      "show-custom-label-in-option": true,
                                      "default-value": _vm.quotation.pol
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.polChange(p)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.POD") } },
                            [
                              _vm.quotation.type !=
                              _vm.PriceConstant.QUOTATION_AIR
                                ? _c("cargo-advance-select", {
                                    ref: "quotationSePod",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "pod",
                                      disabled: !_vm.editing,
                                      filterable: "",
                                      placeholder: _vm.$t("Pricing.PODPrompt"),
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Seaport,
                                      "custom-label": function(item) {
                                        return (
                                          "[" +
                                          item.code +
                                          "]" +
                                          item.englishName
                                        )
                                      },
                                      "filter-tag-names": [
                                        "code",
                                        "englishName"
                                      ],
                                      "show-custom-label-in-option": true,
                                      "default-value": _vm.quotation.pod
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.podChange(p)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm.quotation.type ==
                              _vm.PriceConstant.QUOTATION_AIR
                                ? _c("cargo-advance-select", {
                                    ref: "quotationAirPod",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "pod",
                                      disabled: !_vm.editing,
                                      filterable: "",
                                      placeholder: _vm.$t("Pricing.PODPrompt"),
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Airport,
                                      "custom-label": function(item) {
                                        return (
                                          "[" +
                                          item.code +
                                          "]" +
                                          item.englishName
                                        )
                                      },
                                      "filter-tag-names": [
                                        "code",
                                        "englishName"
                                      ],
                                      "show-custom-label-in-option": true,
                                      "default-value": _vm.quotation.pod
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.podChange(p)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Pricing.PlaceOfDelivery")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  no: "deliveryPlace",
                                  disabled: !_vm.editing
                                },
                                model: {
                                  value: _vm.quotation.deliveryPlace,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.quotation,
                                      "deliveryPlace",
                                      $$v
                                    )
                                  },
                                  expression: "quotation.deliveryPlace"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.Goods") } },
                            [
                              _c("el-input", {
                                attrs: {
                                  no: "goodsName",
                                  disabled: !_vm.editing
                                },
                                model: {
                                  value: _vm.quotation.goodsName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quotation, "goodsName", $$v)
                                  },
                                  expression: "quotation.goodsName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.HsCode") } },
                            [
                              _c("el-input", {
                                attrs: { no: "hsCode", disabled: !_vm.editing },
                                model: {
                                  value: _vm.quotation.hsCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quotation, "hsCode", $$v)
                                  },
                                  expression: "quotation.hsCode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.FreightTerm") } },
                            [
                              _c("el-input", {
                                attrs: {
                                  no: "freightTerm",
                                  disabled: !_vm.editing
                                },
                                model: {
                                  value: _vm.quotation.freightTerm,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quotation, "freightTerm", $$v)
                                  },
                                  expression: "quotation.freightTerm"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("Pricing.BookingAgent") }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "bookingAgent",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  filterable: "",
                                  disabled: !_vm.editing,
                                  "method-params": {
                                    bookingAgent: true,
                                    active: true
                                  },
                                  "default-value":
                                    _vm.quotation.bookingAgent || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.bookingAgentChangeHandler(p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.quotation.type ===
                                  _vm.PriceConstant.QUOTATION_LCL
                                    ? _vm.$t("Pricing.Weight_LCL")
                                    : _vm.$t("Pricing.Weight")
                              }
                            },
                            [
                              _c("el-input-number", {
                                style: _vm.formNumberWidth,
                                attrs: {
                                  no: "grossWeight",
                                  value:
                                    parseFloat(_vm.quotation.grossWeight) === 0
                                      ? undefined
                                      : _vm.quotation.grossWeight,
                                  disabled: !_vm.editing,
                                  precision: 3,
                                  controls: false,
                                  max: 999999999,
                                  min: -999999999
                                },
                                on: {
                                  blur: function($event) {
                                    return _vm.calculateChargeWeight()
                                  },
                                  input: function(val) {
                                    _vm.quotation.grossWeight =
                                      val !== 0 ? val : undefined
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Pricing.Volume") + "(CBM)"
                              }
                            },
                            [
                              _c("el-input-number", {
                                style: _vm.formNumberWidth,
                                attrs: {
                                  no: "cubage",
                                  value:
                                    parseFloat(_vm.quotation.cubage) === 0
                                      ? undefined
                                      : _vm.quotation.cubage,
                                  disabled: !_vm.editing,
                                  precision: 3,
                                  controls: false,
                                  max: 999999999,
                                  min: -999999999
                                },
                                on: {
                                  blur: function($event) {
                                    return _vm.calculateChargeWeight()
                                  },
                                  input: function(val) {
                                    _vm.quotation.cubage =
                                      val !== 0 ? val : undefined
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.Measurement") } },
                            [
                              _c("el-input", {
                                attrs: { no: "size", disabled: !_vm.editing },
                                model: {
                                  value: _vm.quotation.size,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quotation, "size", $$v)
                                  },
                                  expression: "quotation.size"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t("Pricing.ChargedWeight") +
                                  (_vm.quotation.type ===
                                  _vm.PriceConstant.QUOTATION_AIR
                                    ? "(KG)"
                                    : _vm.quotation.type ===
                                      _vm.PriceConstant.QUOTATION_FCL
                                    ? "(T)"
                                    : "(R/T)")
                              }
                            },
                            [
                              _c("el-input-number", {
                                style: _vm.formNumberWidth,
                                attrs: {
                                  no: "chargeWeight",
                                  value:
                                    parseFloat(_vm.quotation.chargeWeight) === 0
                                      ? undefined
                                      : _vm.quotation.chargeWeight,
                                  disabled: !_vm.editing,
                                  precision: 3,
                                  controls: false,
                                  max: 999999999,
                                  min: -999999999
                                },
                                on: {
                                  blur: function($event) {
                                    return _vm.syncChargeWeightToCharge()
                                  },
                                  input: function(val) {
                                    _vm.quotation.chargeWeight =
                                      val !== 0 ? val : undefined
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.quotation.type ===
                            _vm.PriceConstant.QUOTATION_FCL,
                          expression:
                            "quotation.type === PriceConstant.QUOTATION_FCL"
                        }
                      ]
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.Num20") } },
                            [
                              _c("cargo-input-number", {
                                style: _vm.formNumberWidth,
                                attrs: {
                                  no: "num20",
                                  disabled: !_vm.editing,
                                  precision: 0,
                                  controls: false,
                                  max: 999999999,
                                  min: -999999999
                                },
                                on: { change: _vm.onNumChanged },
                                model: {
                                  value: _vm.quotation.num20,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quotation, "num20", $$v)
                                  },
                                  expression: "quotation.num20"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.Num40") } },
                            [
                              _c("cargo-input-number", {
                                style: _vm.formNumberWidth,
                                attrs: {
                                  no: "num40",
                                  disabled: !_vm.editing,
                                  precision: 0,
                                  controls: false,
                                  max: 999999999,
                                  min: -999999999
                                },
                                on: { change: _vm.onNumChanged },
                                model: {
                                  value: _vm.quotation.num40,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quotation, "num40", $$v)
                                  },
                                  expression: "quotation.num40"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.NumHC") } },
                            [
                              _c("cargo-input-number", {
                                style: _vm.formNumberWidth,
                                attrs: {
                                  no: "numHc",
                                  disabled: !_vm.editing,
                                  precision: 0,
                                  controls: false,
                                  max: 999999999,
                                  min: -999999999
                                },
                                on: { change: _vm.onNumChanged },
                                model: {
                                  value: _vm.quotation.numHc,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quotation, "numHc", $$v)
                                  },
                                  expression: "quotation.numHc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.Num45") } },
                            [
                              _c("cargo-input-number", {
                                style: _vm.formNumberWidth,
                                attrs: {
                                  no: "num45",
                                  disabled: !_vm.editing,
                                  precision: 0,
                                  controls: false,
                                  max: 999999999,
                                  min: -999999999
                                },
                                on: { change: _vm.onNumChanged },
                                model: {
                                  value: _vm.quotation.num45,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quotation, "num45", $$v)
                                  },
                                  expression: "quotation.num45"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("el-checkbox", {
                                attrs: {
                                  no: "dangerousGoods",
                                  label: _vm.$t("Pricing.Hazard"),
                                  disabled: !_vm.editing
                                },
                                model: {
                                  value: _vm.quotation.dangerousGoods,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.quotation,
                                      "dangerousGoods",
                                      $$v
                                    )
                                  },
                                  expression: "quotation.dangerousGoods"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.GoodsLevel") } },
                            [
                              _c("el-input", {
                                attrs: {
                                  no: "hazardClass",
                                  disabled: !(
                                    _vm.editing && _vm.quotation.dangerousGoods
                                  ),
                                  maxlength: 64
                                },
                                model: {
                                  value: _vm.quotation.hazardClass,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quotation, "hazardClass", $$v)
                                  },
                                  expression: "quotation.hazardClass"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.UnNo") } },
                            [
                              _c("el-input", {
                                attrs: {
                                  no: "unNo",
                                  disabled: !(
                                    _vm.editing && _vm.quotation.dangerousGoods
                                  ),
                                  maxlength: 64
                                },
                                model: {
                                  value: _vm.quotation.unNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quotation, "unNo", $$v)
                                  },
                                  expression: "quotation.unNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.quantity") } },
                            [
                              _c("el-input-number", {
                                style: _vm.formNumberWidth,
                                attrs: {
                                  no: "quantity",
                                  disabled: !_vm.editing,
                                  precision: 0,
                                  "controls-position": "right",
                                  max: 999999999999,
                                  min: 0
                                },
                                model: {
                                  value: _vm.quotation.quantity,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quotation, "quantity", $$v)
                                  },
                                  expression: "quotation.quantity"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Payment.UserDefinedField1")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  no: "pricingUserDefinedField1",
                                  disabled: !_vm.editing
                                },
                                model: {
                                  value: _vm.quotation.pricingUserDefinedField1,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.quotation,
                                      "pricingUserDefinedField1",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "quotation.pricingUserDefinedField1"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Payment.UserDefinedField2")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  no: "pricingUserDefinedField2",
                                  disabled: !_vm.editing
                                },
                                model: {
                                  value: _vm.quotation.pricingUserDefinedField2,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.quotation,
                                      "pricingUserDefinedField2",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "quotation.pricingUserDefinedField2"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Payment.UserDefinedField3")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  no: "pricingUserDefinedField3",
                                  disabled: !_vm.editing
                                },
                                model: {
                                  value: _vm.quotation.pricingUserDefinedField3,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.quotation,
                                      "pricingUserDefinedField3",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "quotation.pricingUserDefinedField3"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Payment.UserDefinedField4")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  no: "pricingUserDefinedField4",
                                  disabled: !_vm.editing
                                },
                                model: {
                                  value: _vm.quotation.pricingUserDefinedField4,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.quotation,
                                      "pricingUserDefinedField4",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "quotation.pricingUserDefinedField4"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_EnquiryNumber")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.quotation.inquiryPriceNo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.quotation,
                                      "inquiryPriceNo",
                                      $$v
                                    )
                                  },
                                  expression: "quotation.inquiryPriceNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_AssociatedPrePortQuoteNumber"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.quotation.prePortQuotationNo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.quotation,
                                      "prePortQuotationNo",
                                      $$v
                                    )
                                  },
                                  expression: "quotation.prePortQuotationNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_AssociatedLastMileQuoteNumber"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.quotation.lastMileQuotationNo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.quotation,
                                      "lastMileQuotationNo",
                                      $$v
                                    )
                                  },
                                  expression: "quotation.lastMileQuotationNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_Enquirer")
                              }
                            },
                            [
                              _c("cargo-user-select", {
                                attrs: {
                                  "default-value": _vm.quotation.createdBy,
                                  disabled: ""
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_PalletType")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "palletNature",
                                  "tag-value": "code",
                                  filterable: "",
                                  clearable: false,
                                  "default-value": _vm.quotation.palletNature,
                                  "static-options":
                                    _vm.SystemConstants.PALLET_NATURES
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.quotation.palletNature = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.CargoReadyDate")
                              }
                            },
                            [
                              _c(
                                "el-tabs",
                                {
                                  attrs: { disabled: _vm.associatedInquiry },
                                  model: {
                                    value: _vm.quotation.cargoReadyTimeType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.quotation,
                                        "cargoReadyTimeType",
                                        $$v
                                      )
                                    },
                                    expression: "quotation.cargoReadyTimeType"
                                  }
                                },
                                [
                                  _c("el-tab-pane", {
                                    attrs: {
                                      disabled:
                                        !_vm.editing || _vm.associatedInquiry,
                                      label: _vm.$t("CargoMsg.Cargo_Range"),
                                      name:
                                        _vm.SystemConstants
                                          .CARGO_READY_TIME_TYPE_RANGE.code
                                    }
                                  }),
                                  _c("el-tab-pane", {
                                    attrs: {
                                      disabled:
                                        !_vm.editing || _vm.associatedInquiry,
                                      label: _vm.$t("CargoMsg.Cargo_Date"),
                                      name:
                                        _vm.SystemConstants
                                          .CARGO_READY_TIME_TYPE_DATE.code
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm.quotation.cargoReadyTimeType ===
                              _vm.SystemConstants.CARGO_READY_TIME_TYPE_RANGE
                                .code
                                ? _c("cargo-advance-select", {
                                    attrs: {
                                      no: "cargoReadyTimeRange",
                                      "tag-value": "code",
                                      filterable: "",
                                      clearable: false,
                                      "default-value":
                                        _vm.quotation.cargoReadyTimeRange,
                                      "static-options":
                                        _vm.SystemConstants
                                          .CARGO_READY_TIME_RANGES
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.quotation.cargoReadyTimeRange =
                                          p.value
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm.quotation.cargoReadyTimeType ===
                              _vm.SystemConstants.CARGO_READY_TIME_TYPE_DATE
                                .code
                                ? _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "cargoReadyTimeDate",
                                      type: "datetime",
                                      "value-format": "yyyy-MM-dd",
                                      format: "yyyy-MM-dd"
                                    },
                                    model: {
                                      value: _vm.quotation.cargoReadyTimeDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.quotation,
                                          "cargoReadyTimeDate",
                                          $$v
                                        )
                                      },
                                      expression: "quotation.cargoReadyTimeDate"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_20NORQuantity")
                              }
                            },
                            [
                              _c("cargo-input-number", {
                                style: _vm.formNumberWidth,
                                attrs: {
                                  no: "num20Nor",
                                  disabled: !_vm.editing,
                                  precision: 0,
                                  controls: false,
                                  max: 999999999,
                                  min: 0
                                },
                                model: {
                                  value: _vm.quotation.num20Nor,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quotation, "num20Nor", $$v)
                                  },
                                  expression: "quotation.num20Nor"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_40NORQuantity")
                              }
                            },
                            [
                              _c("cargo-input-number", {
                                style: _vm.formNumberWidth,
                                attrs: {
                                  no: "num40Nor",
                                  disabled: !_vm.editing,
                                  precision: 0,
                                  controls: false,
                                  max: 999999999,
                                  min: 0
                                },
                                model: {
                                  value: _vm.quotation.num40Nor,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quotation, "num40Nor", $$v)
                                  },
                                  expression: "quotation.num40Nor"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_Terms") }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "serviceTerm",
                                  filterable: "",
                                  "select-type":
                                    _vm.TYPE_NAMES.basic_data_IncoTerm,
                                  "callback-method-type": "value",
                                  "default-value": _vm.quotation.serviceTerm,
                                  "callback-params": { key: "incoTerm" }
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.quotation.serviceTerm = p.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_DirectOrTransshipment"
                                )
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "directTransit",
                                  "tag-value": "code",
                                  filterable: "",
                                  clearable: false,
                                  "default-value": _vm.quotation.directTransit,
                                  "static-options":
                                    _vm.SystemConstants.DIRECT_TRANSITS
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.quotation.directTransit = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _vm.quotation.directTransit ===
                          _vm.SystemConstants.DIRECT_TRANSIT_TRANSIT.code
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.TransitPort")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      "select-type":
                                        _vm.TYPE_NAMES.basic_data_Seaport,
                                      filterable: "",
                                      "default-value":
                                        _vm.quotation.transferPortCode
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        return (_vm.quotation.transferPortCode =
                                          p.value)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_Airline") }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.TYPE_NAMES.basic_data_Region,
                                  filterable: "",
                                  "default-value": _vm.quotation.commerceCode
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.quotation.commerceCode = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.ShippingCompany")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "carrierId",
                                  filterable: "",
                                  "select-type":
                                    _vm.TYPE_NAMES.basic_data_Company,
                                  "method-params": {
                                    seaCmp: true,
                                    active: true
                                  },
                                  "default-value":
                                    _vm.quotation.carrierId || "",
                                  placeholder: " "
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.quotation.carrierId = p.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "cargoType",
                                  filterable: "",
                                  "select-type":
                                    _vm.TYPE_NAMES.basic_data_CargoType,
                                  "callback-method-type": "value",
                                  "default-value": _vm.quotation.cargoType,
                                  "callback-params": { key: "cargoType" }
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.quotation.cargoType = p.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _vm.quotation.cargoType ===
                          _vm.ImportConstants.CARGOTYPE_DANGEROUS.code
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.DangerousClass")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "dangerousGoodsLevel",
                                      "tag-value": "code",
                                      filterable: "",
                                      clearable: false,
                                      "default-value":
                                        _vm.quotation.dangerousGoodsLevel,
                                      "static-options":
                                        _vm.SystemConstants
                                          .DANGEROUS_GOODS_LEVELS
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.quotation.dangerousGoodsLevel =
                                          p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _vm.quotation.cargoType ===
                          _vm.ImportConstants.CARGOTYPE_DANGEROUS.code
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "UN NO" } },
                                [
                                  _c("el-input-number", {
                                    style: _vm.formNumberWidth,
                                    attrs: {
                                      no: "unNo",
                                      controls: false,
                                      precision: 0,
                                      min: 0,
                                      max: 9999
                                    },
                                    model: {
                                      value: _vm.quotation.unNo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.quotation, "unNo", $$v)
                                      },
                                      expression: "quotation.unNo"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _vm.quotation.cargoType ===
                          _vm.ImportConstants.CARGOTYPE_OOG.code
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "length-weight-height",
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_Dimensions")
                                  }
                                },
                                [
                                  _c("cargo-length-width-height", {
                                    attrs: { form: _vm.quotation }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _vm.quotation.cargoType ===
                          _vm.ImportConstants.CARGOTYPE_FROZEN.code
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.Temperature")
                                  }
                                },
                                [
                                  _c("el-input-number", {
                                    staticStyle: { width: "230px" },
                                    attrs: {
                                      no: "temperature",
                                      controls: false,
                                      precision: 0
                                    },
                                    model: {
                                      value: _vm.quotation.temperature,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.quotation,
                                          "temperature",
                                          $$v
                                        )
                                      },
                                      expression: "quotation.temperature"
                                    }
                                  }),
                                  _c("span", [_vm._v("℃")])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _vm.quotation.cargoType ===
                          _vm.ImportConstants.CARGOTYPE_FROZEN.code
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.VentilationQuantity"
                                    )
                                  }
                                },
                                [
                                  _c("el-input-number", {
                                    staticStyle: { width: "230px" },
                                    attrs: {
                                      no: "ventilationQuantity",
                                      controls: false,
                                      precision: 0
                                    },
                                    model: {
                                      value: _vm.quotation.ventilationQuantity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.quotation,
                                          "ventilationQuantity",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "quotation.ventilationQuantity"
                                    }
                                  }),
                                  _c("span", [_vm._v("%")])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "remarks",
                              placeholder: _vm.$t("Pricing.Remarks"),
                              type: "textarea",
                              rows: 5,
                              disabled: !_vm.editing
                            },
                            model: {
                              value: _vm.quotation.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.quotation, "remarks", $$v)
                              },
                              expression: "quotation.remarks"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.showDetail && !_vm.quotation.uuid,
                      expression: "!showDetail && !quotation.uuid"
                    }
                  ],
                  staticClass: "section",
                  staticStyle: { "text-align": "right" }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { no: "onNextStep", type: "primary" },
                              on: { click: _vm.onNextStep }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Next")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.showDetail
                ? _c(
                    "span",
                    [
                      _c("div", {
                        staticStyle: { "border-bottom": "2px solid #E3E3E3" }
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          staticStyle: {
                            "font-size": "14px",
                            "line-height": "25px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.PriceInfo")))]
                      ),
                      _c(
                        "el-form",
                        {
                          staticClass: "section",
                          attrs: { disabled: !_vm.canUpdate }
                        },
                        [
                          _vm.editing
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            no: "onAddP",
                                            type: "primary"
                                          },
                                          on: { click: _vm.onAdd_P }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("Pricing.NewRate"))
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            no: "onDeleteP",
                                            type: "danger",
                                            disabled: !(
                                              this.priceSource &&
                                              this.priceSource.length > 0
                                            )
                                          },
                                          on: { click: _vm.onDelete_P }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("Pricing.DelRate"))
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            no: "onMarkup",
                                            type: "primary",
                                            disabled: !(
                                              this.priceSource &&
                                              this.priceSource.length > 0
                                            )
                                          },
                                          on: { click: _vm.onMarkup }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("Pricing.MarkupRate"))
                                          )
                                        ]
                                      ),
                                      _vm.quotation.type ==
                                      _vm.PriceConstant.QUOTATION_FCL
                                        ? _c(
                                            "span",
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "10px"
                                                  }
                                                },
                                                [_vm._v("20'")]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "10px"
                                                },
                                                attrs: {
                                                  no: "eq20",
                                                  value:
                                                    Number(
                                                      _vm.qfMarkups.eq20
                                                    ) === 0
                                                      ? undefined
                                                      : _vm.qfMarkups.eq20,
                                                  precision: 2,
                                                  controls: false,
                                                  max: 999999999,
                                                  min: -999999999
                                                },
                                                on: {
                                                  input: function(val) {
                                                    _vm.qfMarkups.eq20 =
                                                      val !== 0
                                                        ? val
                                                        : undefined
                                                  }
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "10px"
                                                  }
                                                },
                                                [_vm._v("40'")]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "10px"
                                                },
                                                attrs: {
                                                  no: "eq40",
                                                  value:
                                                    Number(
                                                      _vm.qfMarkups.eq40
                                                    ) === 0
                                                      ? undefined
                                                      : _vm.qfMarkups.eq40,
                                                  precision: 2,
                                                  controls: false,
                                                  max: 999999999,
                                                  min: -999999999
                                                },
                                                on: {
                                                  input: function(val) {
                                                    _vm.qfMarkups.eq40 =
                                                      val !== 0
                                                        ? val
                                                        : undefined
                                                  }
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "10px"
                                                  }
                                                },
                                                [_vm._v("40'HC")]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "10px"
                                                },
                                                attrs: {
                                                  no: "eqHc",
                                                  value:
                                                    Number(
                                                      _vm.qfMarkups.eqHc
                                                    ) === 0
                                                      ? undefined
                                                      : _vm.qfMarkups.eqHc,
                                                  precision: 2,
                                                  controls: false,
                                                  max: 999999999,
                                                  min: -999999999
                                                },
                                                on: {
                                                  input: function(val) {
                                                    _vm.qfMarkups.eqHc =
                                                      val !== 0
                                                        ? val
                                                        : undefined
                                                  }
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "10px"
                                                  }
                                                },
                                                [_vm._v("45'")]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "10px"
                                                },
                                                attrs: {
                                                  no: "eq45",
                                                  value:
                                                    Number(
                                                      _vm.qfMarkups.eq45
                                                    ) === 0
                                                      ? undefined
                                                      : _vm.qfMarkups.eq45,
                                                  precision: 2,
                                                  controls: false,
                                                  max: 999999999,
                                                  min: -999999999
                                                },
                                                on: {
                                                  input: function(val) {
                                                    _vm.qfMarkups.eq45 =
                                                      val !== 0
                                                        ? val
                                                        : undefined
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.quotation.type ==
                                      _vm.PriceConstant.QUOTATION_LCL
                                        ? _c(
                                            "span",
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "10px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Pricing.WeightPrice"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "10px"
                                                },
                                                attrs: {
                                                  no: "weightPrice",
                                                  value:
                                                    Number(
                                                      _vm.qlMarkups.weightPrice
                                                    ) === 0
                                                      ? undefined
                                                      : _vm.qlMarkups
                                                          .weightPrice,
                                                  precision: 2,
                                                  controls: false,
                                                  max: 999999999,
                                                  min: -999999999
                                                },
                                                on: {
                                                  input: function(val) {
                                                    _vm.qlMarkups.weightPrice =
                                                      val !== 0
                                                        ? val
                                                        : undefined
                                                  }
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "10px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Pricing.VolumePrice"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "10px"
                                                },
                                                attrs: {
                                                  no: "volumePrice",
                                                  value:
                                                    Number(
                                                      _vm.qlMarkups.volumePrice
                                                    ) === 0
                                                      ? undefined
                                                      : _vm.qlMarkups
                                                          .volumePrice,
                                                  precision: 2,
                                                  controls: false,
                                                  max: 999999999,
                                                  min: -999999999
                                                },
                                                on: {
                                                  input: function(val) {
                                                    _vm.qlMarkups.volumePrice =
                                                      val !== 0
                                                        ? val
                                                        : undefined
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.quotation.type ==
                                      _vm.PriceConstant.QUOTATION_AIR
                                        ? _c(
                                            "span",
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "10px"
                                                  }
                                                },
                                                [_vm._v("M")]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "5px",
                                                  width: "100px"
                                                },
                                                attrs: {
                                                  no: "minCharge",
                                                  value:
                                                    Number(
                                                      _vm.qaMarkups.minCharge
                                                    ) === 0
                                                      ? undefined
                                                      : _vm.qaMarkups.minCharge,
                                                  precision: 2,
                                                  controls: false,
                                                  max: 999999999,
                                                  min: -999999999
                                                },
                                                on: {
                                                  input: function(val) {
                                                    _vm.qaMarkups.minCharge =
                                                      val !== 0
                                                        ? val
                                                        : undefined
                                                  }
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "10px"
                                                  }
                                                },
                                                [_vm._v("N")]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "5px",
                                                  width: "100px"
                                                },
                                                attrs: {
                                                  no: "step",
                                                  value:
                                                    Number(
                                                      _vm.qaMarkups.step
                                                    ) === 0
                                                      ? undefined
                                                      : _vm.qaMarkups.step,
                                                  precision: 2,
                                                  controls: false,
                                                  max: 999999999,
                                                  min: -999999999
                                                },
                                                on: {
                                                  input: function(val) {
                                                    _vm.qaMarkups.step =
                                                      val !== 0
                                                        ? val
                                                        : undefined
                                                  }
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "10px"
                                                  }
                                                },
                                                [_vm._v("+45")]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "5px",
                                                  width: "100px"
                                                },
                                                attrs: {
                                                  no: "p45",
                                                  value:
                                                    Number(
                                                      _vm.qaMarkups.p45
                                                    ) === 0
                                                      ? undefined
                                                      : _vm.qaMarkups.p45,
                                                  precision: 2,
                                                  controls: false,
                                                  max: 999999999,
                                                  min: -999999999
                                                },
                                                on: {
                                                  input: function(val) {
                                                    _vm.qaMarkups.p45 =
                                                      val !== 0
                                                        ? val
                                                        : undefined
                                                  }
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "10px"
                                                  }
                                                },
                                                [_vm._v("+100")]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "5px",
                                                  width: "100px"
                                                },
                                                attrs: {
                                                  no: "p100",
                                                  value:
                                                    Number(
                                                      _vm.qaMarkups.p100
                                                    ) === 0
                                                      ? undefined
                                                      : _vm.qaMarkups.p100,
                                                  precision: 2,
                                                  controls: false,
                                                  max: 999999999,
                                                  min: -999999999
                                                },
                                                on: {
                                                  input: function(val) {
                                                    _vm.qaMarkups.p100 =
                                                      val !== 0
                                                        ? val
                                                        : undefined
                                                  }
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "10px"
                                                  }
                                                },
                                                [_vm._v("+300")]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "5px",
                                                  width: "100px"
                                                },
                                                attrs: {
                                                  no: "p300",
                                                  value:
                                                    Number(
                                                      _vm.qaMarkups.p300
                                                    ) === 0
                                                      ? undefined
                                                      : _vm.qaMarkups.p300,
                                                  precision: 2,
                                                  controls: false,
                                                  max: 999999999,
                                                  min: -999999999
                                                },
                                                on: {
                                                  input: function(val) {
                                                    _vm.qaMarkups.p300 =
                                                      val !== 0
                                                        ? val
                                                        : undefined
                                                  }
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "10px"
                                                  }
                                                },
                                                [_vm._v("+500")]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "5px",
                                                  width: "100px"
                                                },
                                                attrs: {
                                                  no: "p500",
                                                  value:
                                                    Number(
                                                      _vm.qaMarkups.p500
                                                    ) === 0
                                                      ? undefined
                                                      : _vm.qaMarkups.p500,
                                                  precision: 2,
                                                  controls: false,
                                                  max: 999999999,
                                                  min: -999999999
                                                },
                                                on: {
                                                  input: function(val) {
                                                    _vm.qaMarkups.p500 =
                                                      val !== 0
                                                        ? val
                                                        : undefined
                                                  }
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "10px"
                                                  }
                                                },
                                                [_vm._v("+1000")]
                                              ),
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "padding-left": "5px",
                                                  width: "100px"
                                                },
                                                attrs: {
                                                  no: "p1000",
                                                  value:
                                                    Number(
                                                      _vm.qaMarkups.p1000
                                                    ) === 0
                                                      ? undefined
                                                      : _vm.qaMarkups.p1000,
                                                  precision: 2,
                                                  controls: false,
                                                  max: 999999999,
                                                  min: -999999999
                                                },
                                                on: {
                                                  input: function(val) {
                                                    _vm.qaMarkups.p1000 =
                                                      val !== 0
                                                        ? val
                                                        : undefined
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-form",
                        {
                          staticClass: "section",
                          attrs: { disabled: !_vm.canUpdate }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _vm.quotation.type ===
                                  _vm.PriceConstant.QUOTATION_FCL
                                    ? _c("cargo-ag-grid", {
                                        key: "22020204",
                                        staticStyle: { flex: "1" },
                                        attrs: {
                                          "config-module": "22020204",
                                          "grid-params": _vm.fcl.gridParams,
                                          "grid-options": _vm.fcl.gridOptions,
                                          "column-defs": _vm.fclColumnDefs,
                                          "row-data": _vm.fclRowData
                                        },
                                        on: {
                                          "update:gridParams": function(
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.fcl,
                                              "gridParams",
                                              $event
                                            )
                                          },
                                          "update:grid-params": function(
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.fcl,
                                              "gridParams",
                                              $event
                                            )
                                          },
                                          gridReady: function(params) {
                                            _vm.fcl.gridApi = params.api
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm.quotation.type ===
                                  _vm.PriceConstant.QUOTATION_LCL
                                    ? _c("cargo-ag-grid", {
                                        key: "22020205",
                                        staticStyle: { flex: "1" },
                                        attrs: {
                                          "config-module": "22020205",
                                          "grid-params": _vm.lcl.gridParams,
                                          "grid-options": _vm.lcl.gridOptions,
                                          "column-defs": _vm.lclColumnDefs,
                                          "row-data": _vm.lclRowData
                                        },
                                        on: {
                                          "update:gridParams": function(
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.lcl,
                                              "gridParams",
                                              $event
                                            )
                                          },
                                          "update:grid-params": function(
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.lcl,
                                              "gridParams",
                                              $event
                                            )
                                          },
                                          gridReady: function(params) {
                                            _vm.lcl.gridApi = params.api
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm.quotation.type ===
                                  _vm.PriceConstant.QUOTATION_AIR
                                    ? _c("cargo-ag-grid", {
                                        key: "22020206",
                                        staticStyle: { flex: "1" },
                                        attrs: {
                                          "config-module": "22020206",
                                          "grid-params": _vm.air.gridParams,
                                          "grid-options": _vm.air.gridOptions,
                                          "column-defs": _vm.airColumnDefs,
                                          "row-data": _vm.airRowData
                                        },
                                        on: {
                                          "update:gridParams": function(
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.air,
                                              "gridParams",
                                              $event
                                            )
                                          },
                                          "update:grid-params": function(
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.air,
                                              "gridParams",
                                              $event
                                            )
                                          },
                                          gridReady: function(params) {
                                            _vm.air.gridApi = params.api
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("div", {
                        staticStyle: { "border-bottom": "2px solid #E3E3E3" }
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          staticStyle: {
                            "font-size": "14px",
                            "line-height": "25px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.OtherCharge")))]
                      ),
                      _vm.editing
                        ? _c(
                            "el-form",
                            {
                              staticClass: "section",
                              attrs: {
                                disabled: !_vm.canUpdate,
                                inline: true,
                                "label-width": "60",
                                "label-position": "left"
                              }
                            },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t("Pricing.Currency")
                                          }
                                        },
                                        [
                                          _c("cargo-advance-select", {
                                            attrs: {
                                              no: "currency",
                                              filterable: "",
                                              clearable: false,
                                              "default-value":
                                                _vm.filter.currency,
                                              "select-type":
                                                _vm.selectTypeNames
                                                  .basic_data_Currency
                                            },
                                            on: {
                                              parentCallBack:
                                                _vm.currencyParentCallBack
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px"
                                          },
                                          attrs: {
                                            no: "onAddC",
                                            type: "primary"
                                          },
                                          on: { click: _vm.onAdd_C }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Pricing.Add")))]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            no: "onDeleteC",
                                            type: "danger",
                                            disabled: !_vm.charge.selectedRow
                                          },
                                          on: { click: _vm.onDelete_C }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("Pricing.Delete"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form",
                        {
                          staticClass: "section",
                          attrs: { disabled: !_vm.canUpdate }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c("cargo-ag-grid", {
                                    key: "22020207",
                                    ref: "chargeDetailGrid",
                                    staticStyle: { flex: "1" },
                                    attrs: {
                                      "config-module": "22020207",
                                      "grid-params": _vm.charge.gridParams,
                                      "grid-options": _vm.charge.gridOptions,
                                      "column-defs": _vm.chargeColumnDefs,
                                      "row-data": _vm.chargeRowData
                                    },
                                    on: {
                                      "update:gridParams": function($event) {
                                        return _vm.$set(
                                          _vm.charge,
                                          "gridParams",
                                          $event
                                        )
                                      },
                                      "update:grid-params": function($event) {
                                        return _vm.$set(
                                          _vm.charge,
                                          "gridParams",
                                          $event
                                        )
                                      },
                                      gridReady: function(params) {
                                        _vm.charge.gridApi = params.api
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.quotation && _vm.quotation.uuid
                        ? _c(
                            "span",
                            [
                              _c("div", {
                                staticStyle: {
                                  "border-bottom": "2px solid #E3E3E3"
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  staticStyle: {
                                    "font-size": "14px",
                                    "line-height": "25px"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("Pricing.FileHistory")))]
                              ),
                              _c(
                                "el-form",
                                {
                                  staticClass: "section",
                                  attrs: {
                                    disabled:
                                      !_vm.editing ||
                                      _vm.quotation.status2 ===
                                        _vm.SystemConstants.QUOTE_STATUS_QUOTED
                                          .code
                                  }
                                },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 24 } },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "toFileQuery",
                                                type: "primary"
                                              },
                                              on: { click: _vm.toFileQuery }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("FileHistory.Refresh")
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "permission",
                                                  rawName: "v-permission",
                                                  value: [
                                                    "button_FileHistory_fileUpload"
                                                  ],
                                                  expression:
                                                    "['button_FileHistory_fileUpload']"
                                                }
                                              ],
                                              attrs: {
                                                no: "upload",
                                                type: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.file.cloudFile.visible = true
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("FileHistory.Upload")
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "permission",
                                                  rawName: "v-permission",
                                                  value: [
                                                    "button_FileHistory_fileDelete",
                                                    "role_FileDownloads_ownFileDelete"
                                                  ],
                                                  expression:
                                                    "['button_FileHistory_fileDelete', 'role_FileDownloads_ownFileDelete']"
                                                }
                                              ],
                                              attrs: {
                                                no: "fileRemove",
                                                type: "danger"
                                              },
                                              on: { click: _vm.fileRemove }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("FileHistory.Delete")
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "fileDownload",
                                                type: "primary"
                                              },
                                              on: { click: _vm.fileDownload }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FileHistory.BatchDownload"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "fileSendEmail",
                                                type: "primary"
                                              },
                                              on: { click: _vm.fileSendEmail }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FileHistory.SendEmail"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form",
                                {
                                  staticClass: "section",
                                  attrs: { disabled: !_vm.editing }
                                },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 24 } },
                                        [
                                          _c("cargo-ag-grid", {
                                            key: "22020208",
                                            staticStyle: { flex: "1" },
                                            attrs: {
                                              "config-module": "22020208",
                                              "grid-params":
                                                _vm.file.gridParams,
                                              "grid-options":
                                                _vm.file.gridOptions,
                                              "column-defs":
                                                _vm.file.columnDefs,
                                              "row-data": _vm.file.rowData
                                            },
                                            on: {
                                              "update:gridParams": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.file,
                                                  "gridParams",
                                                  $event
                                                )
                                              },
                                              "update:grid-params": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.file,
                                                  "gridParams",
                                                  $event
                                                )
                                              },
                                              gridReady: function(params) {
                                                _vm.file.gridApi = params.api
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "quotationDetail",
          attrs: {
            visible: _vm.client.visible,
            title: _vm.$t("Pricing.QuotationClient"),
            width: "600px",
            top: "5vh",
            "close-on-click-modal": false
          },
          on: { close: _vm.onCancelClient }
        },
        [
          _c(
            "div",
            { staticStyle: { "flex-direction": "column" } },
            [
              _c(
                "el-form",
                { staticClass: "section" },
                [
                  _c(
                    "el-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editing,
                          expression: "editing"
                        }
                      ]
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "onSaveClient",
                                disabled: !!(
                                  _vm.client.disableQuotationClientName &&
                                  _vm.client.disableQuotationClientName ===
                                    _vm.client.quotationClient.name
                                ),
                                type: "primary"
                              },
                              on: { click: _vm.onSaveClient }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Save")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { no: "onCancelClient", type: "primary" },
                              on: { click: _vm.onCancelClient }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Cancel")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { no: "onRefreshClient", type: "primary" },
                              on: { click: _vm.onRefreshClient }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Refresh")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  staticClass: "section",
                  attrs: { "label-width": "70px", "label-position": "right" }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 5, type: "flex" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-col",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Pricing.ClientName"),
                                    required: ""
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    ref: "clientName",
                                    attrs: {
                                      no: "name",
                                      disabled: !_vm.editing,
                                      "custom-label": function(item) {
                                        return "" + item.name
                                          ? "[" +
                                              (item.branchId
                                                ? _vm.branchMap.get(
                                                    item.branchId
                                                  )
                                                : _vm.branchMap.get(
                                                    _vm.$store.getters
                                                      .currentOfficeId
                                                  )) +
                                              "]" +
                                              item.name
                                          : ""
                                      },
                                      "show-custom-label-in-option": true,
                                      filterable: "",
                                      "default-value":
                                        _vm.client.quotationClient.name ||
                                        undefined,
                                      cache: false,
                                      "allow-create": true,
                                      "tag-name": "name",
                                      "tag-value": "name",
                                      "filter-tag-names": ["code", "name"],
                                      "static-options": _vm.filter.clientList
                                    },
                                    on: {
                                      parentCallBack: _vm.clientParentCallBack
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Pricing.Contact"),
                                    required: ""
                                  }
                                },
                                [
                                  _c("el-input", {
                                    ref: "clientContact",
                                    attrs: {
                                      no: "clientContact",
                                      maxlength: 32,
                                      disabled: !_vm.editing
                                    },
                                    model: {
                                      value: _vm.client.quotationClient.contact,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.client.quotationClient,
                                          "contact",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "client.quotationClient.contact"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Pricing.Phone"),
                                    required: ""
                                  }
                                },
                                [
                                  _c("el-input", {
                                    ref: "clientPhone",
                                    attrs: {
                                      no: "clientPhone",
                                      maxlength: 32,
                                      disabled: !_vm.editing
                                    },
                                    model: {
                                      value: _vm.client.quotationClient.phone,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.client.quotationClient,
                                          "phone",
                                          $$v
                                        )
                                      },
                                      expression: "client.quotationClient.phone"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("Pricing.Fax") } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "clientFax",
                                      maxlength: 32,
                                      disabled: !_vm.editing
                                    },
                                    model: {
                                      value: _vm.client.quotationClient.fax,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.client.quotationClient,
                                          "fax",
                                          $$v
                                        )
                                      },
                                      expression: "client.quotationClient.fax"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("Pricing.Email") } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "clientEmail",
                                      maxlength: 64,
                                      disabled: !_vm.editing
                                    },
                                    model: {
                                      value: _vm.client.quotationClient.email,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.client.quotationClient,
                                          "email",
                                          $$v
                                        )
                                      },
                                      expression: "client.quotationClient.email"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("Pricing.Owner") } },
                                [
                                  _c("cargo-user-select", {
                                    attrs: {
                                      no: "owner",
                                      "method-params": {
                                        category: "role",
                                        shape: "sales"
                                      },
                                      "default-value":
                                        _vm.client.quotationClient.ownerId || ""
                                    },
                                    on: {
                                      change: function(p) {
                                        _vm.client.quotationClient.ownerId =
                                          p.value || 0
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-col",
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("Pricing.Address") } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "address",
                                      maxlength: 128,
                                      type: "textarea",
                                      rows: 5,
                                      disabled: !_vm.editing
                                    },
                                    model: {
                                      value: _vm.client.quotationClient.address,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.client.quotationClient,
                                          "address",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "client.quotationClient.address"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("Pricing.Remarks") } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "remarks",
                                      maxlength: 255,
                                      type: "textarea",
                                      rows: 5,
                                      disabled: !_vm.editing
                                    },
                                    model: {
                                      value: _vm.client.quotationClient.remarks,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.client.quotationClient,
                                          "remarks",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "client.quotationClient.remarks"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.file.cloudFile.visible,
          job: _vm.fileCloudFileJob,
          lob: _vm.file.cloudFile.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.file.cloudFile, "visible", $event)
          },
          uploadDone: _vm.toFileQuery
        }
      }),
      _vm.file.isShowingDetailForm
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                "close-on-click-modal": false,
                visible: _vm.file.isShowingDetailForm,
                title: _vm.file.showDetailTitle,
                width: "450px"
              },
              on: {
                close: function() {
                  return (_vm.file.isShowingDetailForm = false)
                }
              }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "400px", height: "300px" },
                attrs: {
                  "grid-options": this.file.gridOptionsFileDetail,
                  "column-defs": this.file.columnDefsFileDetail,
                  "row-data": this.file.rowDataFileDetail
                },
                on: {
                  gridReady: function(params) {
                    return (this$1.file.gridApiFileDetail = params.api)
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.file.sendEmailDialog.visible
        ? _c("send-email-dialog", {
            ref: "file.sendEmailDialog",
            attrs: {
              visible: _vm.file.sendEmailDialog.visible,
              context: null,
              job: _vm.fileCloudFileJob,
              source: "quotationDetailDialog",
              "send-email-data": _vm.file.sendEmailDialog
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.file.sendEmailDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: {},
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          staticClass: "quotationDetail",
          attrs: {
            visible: _vm.customerPopup.visible,
            title: _vm.$t("Pricing.AuthorizedClient"),
            width: "400px",
            top: "5vh",
            "close-on-click-modal": false
          },
          on: {
            close: function($event) {
              _vm.customerPopup.visible = false
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "flex-direction": "column" } },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "70px", "label-position": "right" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Pricing.AuthorizedClient") } },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          "method-params": { customer: true, active: true },
                          "default-value":
                            _vm.customerPopup.customerId || undefined
                        },
                        on: {
                          change: function(p) {
                            _vm.customerPopup.customerId = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "customerOkEventHandler",
                        type: "primary",
                        size: "mini"
                      },
                      on: { click: _vm.customerOkEventHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.OK")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "customerCancel", size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.customerPopup.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.CANCEL")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            no: "refuseQuotationDialog",
            visible: _vm.refuseQuotationDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_Tips"),
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.refuseQuotationDialog, "visible", $event)
            },
            close: function($event) {
              _vm.refuseQuotationDialog.visible = false
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "70px", "label-position": "right" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-left": "230px",
                    "margin-top": "5px",
                    "margin-bottom": "5px",
                    "font-size": "larger"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmRejectQuote")))]
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Partners.RefuseRemark") + ":" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "450px" },
                    attrs: { no: "refuseReason", type: "textarea", rows: 6 },
                    model: {
                      value: _vm.refuseQuotationDialog.refuseReason,
                      callback: function($$v) {
                        _vm.$set(_vm.refuseQuotationDialog, "refuseReason", $$v)
                      },
                      expression: "refuseQuotationDialog.refuseReason"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "confirm", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.editStatus(
                        _vm.SystemConstants.QUOTE_ACTION_REFUSE.code
                      )
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function(p) {
                      _vm.refuseQuotationDialog.refuseReason = ""
                      _vm.refuseQuotationDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }